export default [
	{
		path: "/pros/website",
		exact: true,
		policy: "providerAuth",
		component: "WebsiteBuilder",
		mui: true,
	},
];
